import React from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../../REDUX/actions/confirmationModal";
import { deleteShowRoom } from "../../REDUX/actions/revendeur";
import CustomButton from "../Common/CustomButton";
import { useNavigate } from "react-router-dom";

const ShowRoomCard = ({ showroom, index }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(deleteShowRoom(showroom.id));
  };

  const showModal = () =>
    dispatch(
      openModal({
        type: "delete",
        confirmButtonText: "Supprimer",
        cancelButton: true,
        message: "Êtes-vous sûr(e) de vouloir supprimer le revendeur ?",
        callBack: handleDelete,
      })
    );

  const goTo = () => {
    navigate(`/agence/${showroom.id}`, { state: { id: showroom.id } });
  };

  return (
    <div
      className={`w-98 mx-auto my-2 row py-4 align-items-center rounded-10 ${
        index % 2 === 0 ? "bg-lightGrey" : ""
      }`}
    >
      <div className="col-4 text-start">{showroom?.attributes.name}</div>
      <div className="col-5 text-start">
        {showroom?.attributes.adress.data.attributes.fullAdress}
      </div>
      <div className="col-3 text-start row justify-content-start">
        <div className="col-6">
          <CustomButton
            buttonText={"Enregistrer"}
            iconStart="pencil-fill"
            callBack={goTo}
          />
        </div>
        <div className="col-6">
          <CustomButton
            buttonText={"Supprimer"}
            type="red"
            iconStart="trash3-fill"
            callBack={showModal}
          />
        </div>
      </div>
    </div>
  );
};

export default ShowRoomCard;
